export default __webpack_public_path__ + "static/media/QC-4U-REAR.332f4693.png";